const initialState = {
  data: [],
  loading: false,
  error: false,
};

export function avgTicketAnalytics(state = initialState, action) {
  switch (action.type) {
    case "AVG_TICKET_ANALYTICS_FETCH_DATA_SUCCESS":
      return { ...state, data: action.data, error: false };
    default:
      return state;
  }
}
